import { ApiResponse, AxiosErrorCustom, axiosInstance } from '@/lib/axios';
import { TypedMutationConfig } from '@/lib/react-query';
import { useMutation } from '@tanstack/react-query';
import { z } from 'zod';
import { TLabelCustomer } from '../types/label-customer.type';

/**
 * Create Label Customer API
 */
export const createLabelCustomerValidationSchema = z.object({
  name: z.string().min(1, { message: 'Label Customer name is required' }),
  color: z.string().min(1, { message: 'Label Customer color is required' }),
});

export type TCreateLabelCustomerValidation = z.infer<typeof createLabelCustomerValidationSchema>;
export type TCreateLabelCustomerPayload = TCreateLabelCustomerValidation;
export type TCreateLabelCustomerResponse = ApiResponse<TLabelCustomer>;

export const createLabelCustomer = async (data: TCreateLabelCustomerPayload): Promise<TCreateLabelCustomerResponse> => {
  const url = '/label-customer';

  return axiosInstance.post(url, data);
};

/**
 * Use Create Label Customer React-Query Hook
 */
type TUseCreateLabelCustomerMutationOptions = {
  mutationConfigOptions?: TypedMutationConfig<typeof createLabelCustomer, AxiosErrorCustom>;
};

export const useCreateLabelCustomerMutation = ({ mutationConfigOptions }: TUseCreateLabelCustomerMutationOptions) => {
  const { ...restConfigOptions } = mutationConfigOptions ?? {};

  return useMutation({
    mutationFn: createLabelCustomer,
    ...restConfigOptions,
  });
};
